import { Combobox, type ComboboxProps } from '../ui/Combobox';
import { FieldLabel } from './FieldLabel';

export interface ComboboxFieldProps extends ComboboxProps {
  required?: boolean;
  optional?: boolean;
  labelVariant?: 'bold' | 'caps';
  /** Figma Step-1 style: label rendered as the input placeholder instead of above the field. */
  floating?: boolean;
}

/** Combobox with a visible label above it (or floating label-as-placeholder). */
export function ComboboxField({
  label,
  required = false,
  optional = false,
  labelVariant = 'caps',
  floating = false,
  ...comboboxProps
}: ComboboxFieldProps) {
  const placeholder = floating
    ? (comboboxProps.placeholder ?? `${label}${required ? '*' : ''}`)
    : comboboxProps.placeholder;

  return (
    <div className="flex flex-col gap-1.5">
      {!floating && (
        <FieldLabel label={label} required={required} optional={optional} variant={labelVariant} />
      )}
      <Combobox label={label} {...comboboxProps} placeholder={placeholder} />
    </div>
  );
}
